export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Directora de Museo · Buenos Aires',
    'En una tarde tenía más material sobre museología contextualizado en Argentina que en toda mi carrera profesional. Ahora mis alumnos y colegas me preguntan sobre colecciones, conservación, exposiciones, educación y gestión de museos, y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-deep',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Docente de Museología · Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre un museo tradicional y un espacio de inclusión y accesibilidad, y analizaron casos reales de museos comunitarios de Argentina con marcos normativos vigentes. El nivel de participación en las clases se multiplicó.',
    'bg-petrol',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Patrimonio · Córdoba',
    'Las simulaciones de proyectos museísticos con las plantillas del MEGAPACK son exactamente lo que necesitaba: presupuesto real, organismos argentinos, normativas internacionales actualizadas, estrategias de mediación educativa. Cambió la forma en que planifico todo el año.',
    'bg-violet',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Museología',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué los museos son espacios de inclusión, qué dice la normativa internacional sobre conservación preventiva, y por qué cada iniciativa de patrimonio existe porque alguien decidió que el acceso a la cultura debe ser igual para todos. Mis alumnos empezaron a ver la museología como una responsabilidad social. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Museología',
    'Cuando explicás que el museo no es solo un lugar con objetos en vitrinas, sino un espacio de acceso equitativo al patrimonio, mediación educativa y defensa de la memoria, empieza un debate sobre responsabilidad cultural y derechos comunitarios que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Museología',
    'Cuando mis alumnos descubren que Argentina tiene museos que están transformando comunidades enteras, que son espacios de acceso igualitario a la tecnología en contextos de brecha digital, que la mediación educativa de un museólogo puede cambiar la trayectoria de un estudiante, empieza una conversación sobre el valor de lo comunitario que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Museología',
    'Cerré mi plan anual de gestión museística en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con normativas actualizadas, 100 proyectos para elegir y adaptar, actividades para cada mes y evaluación de impacto integrada.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Museología',
    'Cuando les digo a mis alumnos que el museólogo que trabaja en una comunidad rural de La Rioja está haciendo lo mismo que los curadores de los grandes museos del mundo: garantizando derechos de acceso, preservando patrimonio, educando ciudadanos culturales críticos y cambiando vidas con cada mediación educativa, les estoy enseñando lo que significa la responsabilidad cultural en el mundo real.',
  ],
];
